export class Sticky {

    constructor () {
        this.scrollEvent();
        $(window).scroll(()=>this.scrollEvent());
    }

    private scrollEvent() {
        var scrollTop=$(window).scrollTop();
        if (scrollTop===undefined) return;
        $('html').toggleClass('sticky',scrollTop>0);
    }

}

new Sticky();

export {};